import Vue from 'vue';

export class Chip{

    static create(){

        let street = {};

        street.operadora = null;
        street.numero = null;
        street.imei = null;

        return street;
    }

    /**
     *
     * @param id_chip
     * @return {Promise}
     */
    static byPK(id_chip){
        return new Promise((ok, fail) => {
            Vue.http.get('chip/by-pk/'+ id_chip)
                .then((res) =>  ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_chip
     * @return {Promise}
     */
    static remove(id_chip){
        return new Promise((ok, fail) => {
            Vue.http.delete('chip/by-pk/'+ id_chip)
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }

    static grid(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/chips')
                .then((res) => {
                    ok(res.data);
                })
                .catch(() => {
                    fail();
                });
        });
    }

    static gridV2(){
        return Vue.http.get('grid/chips/v2');
    }

    static gridMobile(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/chips/mobile')
                .then((res) => ok(res.data))
                .catch((e) => {
                    fail(e);
                });
        });
    }

    /**
     *
     * @param id_chip
     * @returns {Promise}
     */
    static combo(id_chip){
        return new Promise((ok, fail) => {
            Vue.http.get('chip/disponiveis/'+ id_chip)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param json
     * @returns {Promise}
     */
    static save(json){
        return new Promise((ok, fail) => {

            let promisse = null;

            if(json.id_chip){
                promisse = Vue.http.put('chip/by-pk/'+ json.id_chip, json);
            } else {
                promisse = Vue.http.post('chip/by-pk/0', json);
            }

            promisse
                .then((res) => ok(res.data))
                .catch((err) => fail(err));

        });
    }

}
